import React from 'react';
import styles from './objectional-notify.scss';
const ObjectionalNotify = props => {
    const {showLink=false,showModal} = props;
    const linkStyle = {

     "color": "#0086FF",
    "marginTop": "5px",
    "text-decoration": "underline",
    "cursor":"pointer",
    }
    let msg = props.tabKey == 'productConflict'?
        <>
            We enhance products details from the product library based on the barcode uploaded. We have identified multiple products having the same barcode uploaded by you.
            <br />
            <span>You can choose to select the matching product or ignore the suggestion.</span>
        </>
            :`We have identified objectionable content in the following ${props?.newProfile == 3 || props?.selectedType=='service' ? "service" : "product"}s' details. They will go live only post moderation by the audit team.`
    return(
        <>
            {
                props.isAuditor ? <div className = {styles['objectional-notify-section'] + " " + styles['auditor'] + " " + (props.isBulkUpload ? styles['objectional-notify-section-bulk'] : '')}>
                    <div className = {"icon-Info" + " " +styles['objectional-notify-icon']}></div>
                    <div className = {styles['objectional-notify-text']}>
                        <div>{`Following objectionable content has been found in this ${props?.newProfile == 3 || props?.selectedType=='service' ? "service" : "product"}:`}</div>
                        <div className={styles['objectional-auditor-text']}>
                            {props.isAuditor.map(error=>{
                                return <div className={styles['objectional-error']}>
                                            <span className={styles["highlight"]}>{error.name}:</span> {error.details}
                                        </div>
                            })}
                        </div>
                    </div>
                </div> :
                <div className = {styles['objectional-notify-section'] + " " + (props.isBulkUpload ? styles['objectional-notify-section-bulk'] : '')}>
                    <div className = {"icon-Info" + " " +styles['objectional-notify-icon']}></div>
                    <div className = {styles['objectional-notify-text']}>
                    {props.isBulkUpload ? "Note:" : ""} {msg}
                    {props.isBulkUpload ? (
                        <div className = {styles['objectional-notify-subtext']}>
                            {`These ${props?.newProfile == 3 || props?.selectedType=='service' ? "services" : "products"} will be visible under the`}<span className = {styles['objectional-notify-subtext-highlight']}> {`Objectionable ${props?.newProfile == 3 || props?.selectedType=='service' ? "Services" : "Products"}`} </span>till they get moderated.
                            </div>
                    ) : null}
                    {showLink && <div style={linkStyle} onClick={showModal}>See Objectionable Error(s)</div>}
                    </div>
                </div>
            }
        </>
    )
}
export default ObjectionalNotify;